export default "__VITE_ASSET__a95b0ff4__"